<i18n src="./../../i18n/product_page.json"></i18n>

<template>
    <div v-if="loaded">
        <div v-if="exist" class="container-fluid">
            <vue-headful
                    :title="itemData.title + ' | mToilet'"
                    :description="itemData.description"
                    :url="pageUrl"/>

            <navigation-bar />

            <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image" data-bg="/assets/mt-cart-header-image.jpg">
                <div class="container">
                    <p class="display-1 mt-f-regular par-text-1"></p>
                </div>
            </div>

            <div class="container-fluid mt-subpage-section m-0 p-0">
                <div class="container-fluid m-0 p-0">
                    <div class="lazy container-fluid">

                        <div class="container">
                            <div class="content-container p-3 pt-5">

                                <div class="container m-lg-3">
                                    <h1 class="text-center product-title" v-text="itemData.name"/>
                                    <div class="row no-gutters">
                                        <div class="col-lg-6">
                                            <div v-if="itemData.image360" class="image-360-logo">
                                                <img src="/assets/mt-360-logo.png" v-on:click="show360Model">
                                            </div>
                                            <img class="main-image lazy" :data-src="itemData.thumbnail" width="350" height="300" :alt="itemData.thumbnailAlt"/>
                                        </div>
                                        <div class="col-lg-6 my-auto">
                                            <ul>
                                                <li v-for="feature in itemData.features" :key="feature">
                                                    {{ feature }}
                                                </li>
                                                <li v-if="itemData.datasheet">
                                                    {{ $t('content.datasheet.see') }} <a :href="itemData.datasheet" v-text="$t('content.datasheet.name')"/>
                                                </li>
                                            </ul>
                                            <div class="container pt-2 product-var">

                                                <div class="container p-0">
                                                    <h3 v-text="$t('cart.addToCart')" />
                                                    <div v-if="itemData.category === categoryToilets">
                                                        <!--liczba osób-->
                                                        <div class="row no-gutters pt-3">
                                                            <div class="col-6 pl-2 my-auto">
                                                                {{ $t('cart.numberOfPeople') }}:
                                                            </div>
                                                            <div class="col-6 no-gutters mt-q-input">
                                                                <div class="number-input">
                                                                    <button v-on:click="function () {selected.numberOfPeople > 1 ? selected.numberOfPeople-- : ''; updateDefaultQuantityAndService();}"></button>
                                                                    <input class="quantity mt-cart-quantity" name="quantity" v-model="selected.numberOfPeople" type="number" @change="updateDefaultQuantityAndService()">
                                                                    <button v-on:click="function () {selected.numberOfPeople++; updateDefaultQuantityAndService();}" class="plus"></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!--liczba kabin-->
                                                        <div class="row no-gutters pt-3">
                                                            <!--wyjątek dla umywalki :(-->
                                                            <div v-if="itemData.name.toLowerCase().includes(exceptionWashbasin)" class="col-6 pl-2 my-auto">
                                                                {{ $t('cart.numberOfItems') }}:
                                                            </div>
                                                            <div v-else class="col-6 pl-2 my-auto">
                                                                {{ $t('cart.numberOfCabins') }}:
                                                            </div>
                                                            <div class="col-6 no-gutters mt-q-input">
                                                                <div class="number-input">
                                                                    <button v-on:click="selected.quantity > 1 ? selected.quantity-- : ''" ></button>
                                                                    <input class="quantity mt-cart-quantity" name="quantity" v-model="selected.quantity" type="number">
                                                                    <button v-on:click="selected.quantity++" class="plus"></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!--częstotliwość serwisu-->
                                                        <div class="row no-gutters pt-2">
                                                            <div class="col-6 pl-2 my-auto">
                                                                {{ $t('cart.serviceFrequency') }}:
                                                            </div>
                                                            <div class="col-6 no-gutters">
                                                                <select class="mt-form-control" v-model="selected.variation" v-on:change="updatePrice()">
                                                                    <option v-for="service in itemData.services" :key="service.id" v-bind:value="service.id" v-text="service.serviceType"/>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="itemData.category === categoryContainers">
                                                        <div class="row no-gutters pt-3">
                                                            <div class="col-6 pl-2 my-auto">
                                                                {{ $t('cart.numberOfContainers') }}:
                                                            </div>
                                                            <div class="col-6 no-gutters mt-q-input">
                                                                <div class="number-input">
                                                                    <button v-on:click="selected.quantity > 1 ? selected.quantity-- : ''" ></button>
                                                                    <input class="quantity mt-cart-quantity" name="quantity" v-model="selected.quantity" type="number">
                                                                    <button v-on:click="selected.quantity++" class="plus"></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="itemData.category === categoryFences">
                                                        <div class="row no-gutters pt-3">
                                                            <div class="col-6 pl-2 my-auto">
                                                                {{ $t('cart.meters') }}:
                                                            </div>
                                                            <div class="col-6 no-gutters mt-q-input">
                                                                <div class="number-input">
                                                                    <button v-on:click="selected.quantity > 1 ? selected.quantity-- : ''" ></button>
                                                                    <input class="quantity mt-cart-quantity" name="quantity" v-model="selected.quantity" type="number">
                                                                    <button v-on:click="selected.quantity++" class="plus"></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="itemData.category === categoryOthers">
                                                        <div class="row no-gutters pt-3">
                                                            <div class="col-6 pl-2 my-auto">
                                                                {{ $t('cart.numberOfItems') }}:
                                                            </div>
                                                            <div class="col-6 no-gutters mt-q-input">
                                                                <div class="number-input">
                                                                    <button v-on:click="selected.quantity > 1 ? selected.quantity-- : ''" ></button>
                                                                    <input class="quantity mt-cart-quantity" name="quantity" v-model="selected.quantity" type="number">
                                                                    <button v-on:click="selected.quantity++" class="plus"></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row pt-4">
                                                        <div v-if="this.itemData.canBuy" class="col-6 my-auto text-right text-nowrap"><span class="price">{{ (selected.quantity * selected.price).toFixed(2) }} {{ currencyShort }}</span> <span class="mt-quantity">/{{ $t('cart.4WeekPrice') }}</span></div>
                                                        <div v-else class="col-6"/>
                                                        <div class="col-6">
                                                            <button class="btn btn-primary btn-lg mt-button mt-button-primary add-to-cart" v-on:click="addToCart()" v-text="$t('cart.addToCart')" />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row mt-5">
                                        <div class="col-12 p-1 product-page-description" v-html="itemData.summary"/>
                                    </div>
                                    <div class="mt-vspace-1"></div>
                                </div>

                            </div>

                            <main-footer/>

                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div v-else id="404-page">
            <page-not-found/>
        </div>
        <div v-if="itemData.image360" class="modal fade text-center" id="tModal" tabindex="-1" role="dialog" aria-labelledby="modalLabel"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <Pano :source="itemData.image360"></Pano>
                </div>
                <div class="modal-front"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {Const} from "@/main";
    import NavigationBar from "@/components/commons/NavigationBar";
    import MainFooter from "@/components/commons/MainFooter";
    import PageNotFound from "@/components/commons/PageNotFound";
    import VanillaToasts from 'vanillatoasts'
    import 'vanillatoasts/vanillatoasts.css'
    import LazyLoad from "vanilla-lazyload"
    import {Pano} from 'vuejs-vr'
    import $ from "jquery";

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    export default {
        name: "ProductPage",
        components: {PageNotFound, MainFooter, NavigationBar, Pano},
        data () {
            return {
                locale: this.$i18n.locale,
                currencyShort: Const.PRIMARY_CURRENCY_SHORT,
                exceptionWashbasin: Const.EXCEPTION_WASHBASIN,
                categoryToilets: Const.CATEGORY_TOILETS,
                categoryContainers: Const.CATEGORY_CONTAINERS,
                categoryFences: Const.CATEGORY_FANCIES,
                categoryOthers: Const.CATEGORY_OTHERS,
                itemData: {},
                configuration: {},
                exist: false,
                loaded: false,
                selected: {
                    id: Number,
                    numberOfPeople: Number,
                    quantity: Number,
                    variation: Number,
                    price: Number
                },
                pageUrl: Const.HOST + this.$route.path
            }
        },
        mounted () {
            axios.all([
                axios.get(`${Const.API_HOST}/${this.locale}/content/product/page`, {
                    params: {
                        "url": '/' + this.$route.params.productName
                    }
                }),
                axios.get(`${Const.API_HOST}/${this.locale}/content/offer/configuration`)
            ])
            .then(responseArr => {
                this.exist = (responseArr[0].status === 200)
                this.itemData = responseArr[0].data
                this.configuration = responseArr[1].data
                this.loaded = true

                this.selected.id = this.itemData.id;
                this.selected.numberOfPeople = 1;
                this.selected.quantity = 1;
                this.selected.variation = this.getDefaultVariation();
                this.selected.price = this.itemData.canBuy ? this.getServicePriceById(this.selected.variation) : 0;

                this.$nextTick(() => {
                    lazyLoadInstance.update()
                })
            });
            $(document).on('shown.bs.modal','#tModal', function () {
                let event
                if(document.createEvent){
                    event = document.createEvent("HTMLEvents");
                    event.initEvent("resize", true, true);
                    event.eventName = "resize";
                    document.getElementById('tModal').dispatchEvent(event);
                } else {
                    event = document.createEventObject();
                    event.eventName = "resize";
                    event.eventType = "resize";
                    $('#tModal').fireEvent("on" + event.eventType, event);
                }
                $(".modal-front").addClass("transparent");
                $(".modal-content div:nth-child(3)").show()
            })
        },
        methods: {
            updatePrice() {
                if (this.itemData.canBuy) {
                    this.selected.price = this.getServicePriceById(this.selected.variation);
                }
            },
            addToCart() {
                this.$store.dispatch('addToCart', {
                    id: this.selected.id,
                    variation: this.selected.variation,
                    quantity: this.selected.quantity,
                    category: this.itemData.category,
                    canBuy: this.itemData.canBuy,
                    name: this.itemData.name,
                    url: this.itemData.url,
                    thumbnail: this.itemData.thumbnail,
                    features: this.itemData.features.slice(0, 3),
                    availableAdditionalServices: this.itemData.additionalServices,
                    possibleVariations: this.itemData.services
                });
                VanillaToasts.create({
                    title: this.$t('messages.productAdded'),
                    type: 'success',
                    timeout: 2000,
                });
            },
            getServicePriceById(id) {
                if (this.itemData.canBuy) {
                    for (let key in this.itemData.services) {
                        if (this.itemData.services[key].id === id)
                            return this.itemData.services[key].grossPrice;
                    }

                    return '-';
                }
            },
            getServiceDescriptionById(id) {
                for (let key in this.itemData.services) {
                    if (this.itemData.services[key].id === id)
                        return this.itemData.services[key].serviceType;
                }

                return '-';
            },
            getDefaultVariation() {
                if (this.itemData.category === this.categoryToilets) {
                    return Math.max.apply(Math, this.itemData.services.map(function(o) { return o.id; }))
                } else {
                    return 0;
                }
            },
            updateDefaultQuantityAndService() {
                let conf = this.configuration.find(obj => {
                    return obj.numberOfPeople >= this.selected.numberOfPeople
                })
                this.selected.quantity = conf.numberOfProducts
                this.selected.variation = Math.min(this.getDefaultVariation(), conf.serviceId)
                this.updatePrice()
            },
            show360Model() {
                $('#tModal').modal()
            }
        }
    }
</script>

<style scoped>
    #paralax-subpage-section {
        height: 200px;
    }

    .product-title {
        font-size: 2rem;
        font-weight: 500;
    }
    .mt-form-control {
        display: block;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem .75rem;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        -webkit-transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    }

    select {
        width: 144px;
    }

    .price {
        font-size: 1.3rem;
        font-weight: 700;
        color: #e30613;
    }

    .mt-quantity {
        font-size: 0.8rem;
        color: #999fa5;
    }

    .product-page-description /deep/.par-with-images {
        text-align: center;
    }

    .product-page-description /deep/.par-with-images img {
        max-width: 350px;
        height: auto;
    }

    .image-360-logo {
        position: absolute;
    }

    .image-360-logo img {
        width: 80px;
        cursor: pointer;
        background: white;
        border-radius: 5px;
    }

    .modal-content {
        display: block;
        height: 600px;
    }

    .modal-front {
        position: absolute;
        height: 600px;
        width: 100%;
        background-color: black;
    }

    .modal-front.transparent {
        background-color: transparent;
        -webkit-transition: background-color 0.3s ease-in-out;
        -moz-transition: background-color 0.3s ease-in-out;
        -o-transition: background-color 0.3s ease-in-out;
        transition: background-color 0.3s ease-in-out;
    }

    .modal-content /deep/ div:nth-child(3) {
        display: none;
    }
</style>